export default {
    basename: '/partner/',
    rtlLayout: false,
    i18n: 'en',
    navType:"light",
};
